import React, { createRef, useEffect, useState } from 'react';
import Header from '../../components/common/global-top-bar';
import RouteLeavingGuard from '../../components/route-leaving-prompt';
import { ROUTE_PATH } from '../../routes/paths';
import { useHistory } from 'react-router-dom';
import { Spinner } from '../../components/common';
import { useSystemSettings, useUpdateSystemSettings } from '../../hooks/useSettings';

const Files = () => {
  const history = useHistory();
  const [welcomeVideo, setWelcomeVideo] = useState<any>();
  const updateSystemSettings = useUpdateSystemSettings();
  const { data: systemWelcomeVideo, isLoading } = useSystemSettings('WELCOME_VIDEO');
  const [isDataModified, setIsDataModified] = useState(false);
  const [saveLocationPath, setSaveLocationPath] = useState<string>('');

  const fileInputWelcomeVideo: any = createRef();

  const hadleImageinput = (name: string) => {
    if (name === 'welcomeVideo') {
      fileInputWelcomeVideo.current.click();
    }
  }; // fileInputWelcomeAuthor

  const onFileChange = async (event: any) => {
    try {
      if (event.target.files && event.target.files[0]) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          setWelcomeVideo(e.target.result);
          // setpreLoadedWelcomeVideo(false);
        };
        reader.readAsDataURL(event.target.files[0]);
        setIsDataModified(true);
      }
    } catch (error) {}
  };

  const saveWelcomeVideo = () => {
    updateSystemSettings.mutate({
      setting: 'WELCOME_VIDEO',
      input: {
        value: welcomeVideo,
      },
    });
  };

  useEffect(() => {
    if (systemWelcomeVideo?.WELCOME_VIDEO) {
      setWelcomeVideo(systemWelcomeVideo?.WELCOME_VIDEO);
      setIsDataModified(false);
      if (saveLocationPath !== '') {
        history.push(saveLocationPath);
      }
    }
  }, [systemWelcomeVideo]); // eslint-disable-line

  return (
    <div>
      {isLoading && <Spinner alignmentClass={'left-64 top-20 fixed z-100 inset-0 overflow-y-auto'} />}
      <RouteLeavingGuard
        when={isDataModified}
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: any) => {
          if (location.pathname !== ROUTE_PATH.GROUPS_CONFIGURE) {
            return true;
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={'You have unsaved changes. Do you want to leave this page and lose your changes?'}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Disregard changes'}
        confirmSaveButtonText={welcomeVideo === null ? undefined : 'Continue and Save changes'}
        handleContinueSaveChange={(path) => {
          saveWelcomeVideo();
          setSaveLocationPath(path);
          setIsDataModified(false);
        }}
      />
      <Header heading={'Files'} />
      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-7">
          <p className="text-gray-dark py-4 font-medium">WELCOME VIDEO</p>
          <div className="flex">
            <div
              className={`${
                welcomeVideo ? '' : 'cursor-pointer'
              } bg-gray-background-light aspect-ratio-container w-full rounded-sm`}
              onClick={() => hadleImageinput('welcomeVideo')}
            >
              {welcomeVideo ? (
                <div>
                  <video width="100%" controls>
                    <source src={welcomeVideo} />
                    Your browser does not support HTML5 video.
                  </video>
                </div>
              ) : (
                <div className="flex h-56 items-center justify-center">
                  <button className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-4xl">
                    +
                  </button>
                  <input
                    ref={fileInputWelcomeVideo}
                    id="file-upload-promotion-overlay-video"
                    accept="video/mp4,video/x-m4v,video/*"
                    type="file"
                    className="hidden"
                    onChange={(e) => onFileChange(e)}
                    onClick={() => {
                      fileInputWelcomeVideo.current.value = null;
                    }}
                  />
                </div>
              )}
            </div>
            <div className="pl-4">
              {welcomeVideo && (
                <div className="aspect-ratio-container w-full">
                  <button
                    className="my-2 w-full rounded-full bg-gray-300 p-2 text-center text-sm text-white"
                    onClick={() => {
                      setWelcomeVideo(null);
                      setIsDataModified(true);
                    }}
                  >
                    REMOVE
                  </button>
                  {isDataModified && (
                    <button
                      className="stacked-bar-blue-400 my-2 w-full rounded-full p-2 text-center text-sm text-white"
                      onClick={saveWelcomeVideo}
                    >
                      SAVE
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Files;
